import { YoutubeAnalyticsPostsPayload } from '@anytag/graphql';
import { TableV2 } from '@anytag/shared-atoms';
import { InfluencerYoutubeAnalyticsPostDetailsModal } from '@anytag/shared-molecules';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { useInfluencerYoutubeVideosTable } from './hooks';

interface InfluencerYoutubeVideosTableProps extends TableData<YoutubeAnalyticsPostsPayload> {
  mainSocialAccountId?: number;
}

export const InfluencerYoutubeVideosTable = ({
  loading,
  data = [],
  mainSocialAccountId
}: InfluencerYoutubeVideosTableProps) => {
  const { columns } = useInfluencerYoutubeVideosTable();

  return (
    <>
      <TableV2 data={data} loading={loading} columns={columns} rowHeight="57px" noTopBorderRadius hasBorder />

      <InfluencerYoutubeAnalyticsPostDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), mainSocialAccountId }))}
      />
    </>
  );
};
